
import { FAQResponse } from '@/components/faq-serp/types';
import { generateFAQs } from '@/services/faq-expert';
import { toast } from 'sonner';

/**
 * Handles the FAQ generation process for a given content and domain
 */
export async function handleFaqGeneration(
  content: string, 
  domain: string
): Promise<FAQResponse> {
  try {
    // Validate inputs before proceeding
    if (!content || content.trim().length < 50) {
      throw new Error("Content is too short. Please provide more substantial content.");
    }

    if (!domain) {
      throw new Error("Domain is required for FAQ generation.");
    }

    // Call the FAQ generation service directly without toast (let the calling component handle UI feedback)
    const response = await generateFAQs(content, domain);
    return response;
  } catch (error) {
    // Handle specific error cases and re-throw for calling component to handle
    console.error("Error in FAQ generation:", error);
    throw error;
  }
}
